<div class="d-block w-100 bg-primary">
  <div class="container">
    <div
      class="game-nav d-flex flex-row align-items-center justify-content-start"
      [ngClass]="{ 'container justify-content-start': isRulesEnabled }"
    >
      <a
        class="nav-item"
        [ngClass]="{ 'nav-item-pickaplayer': isRulesEnabled }"
        [routerLink]="['/games/' + routeLink]"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{ 'game.nav.' + routeLink + '.v2.screenreader' | translate }}"
      >
        <label>{{ routeLink + '.v2.nav.featured' | translate: { fgbdefault: 'Play' } }}</label>
      </a>
      <a
        class="nav-item"
        [ngClass]="{ 'nav-item-pickaplayer': isRulesEnabled }"
        [routerLink]="['/games/' + routeLink + '/leaderboard']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
        attr.aria-label="{{ 'game.nav.' + routeLink + '.v2.leaderboard.screenreader' | translate }}"
      >
        <label>{{ 'games.nav.' + routeLink + '.v2.leaderboard' | translate: { fgbdefault: 'Leaderboard' } }}</label>
      </a>
    </div>
  </div>
</div>
